export default __webpack_public_path__ + "static/media/payment-icon.2a21b3b4.svg";